import { z } from 'zod';

export const CategoryFormSchema = z.object({
    image: z.any().nullable(),
    title: z.string().min(1, 'Le titre est requis').max(100, 'Le titre ne peut pas dépasser 100 caractères'),
    indexDisplay: z.number().int().min(0, "L'index d'affichage doit être positif"),
    isPunctual: z.boolean(),
    isFreefood: z.boolean(),
    isMicrostore: z.boolean(),
    isTitreRestaurantAllowed: z.boolean(),
    shouldShowSubcategories: z.boolean(),
});

export type CategoryFormData = z.infer<typeof CategoryFormSchema>;

export const defaultCategoryValues: CategoryFormData = {
    image: null,
    title: '',
    indexDisplay: 0,
    isPunctual: false,
    isFreefood: false,
    isMicrostore: false,
    isTitreRestaurantAllowed: false,
    shouldShowSubcategories: false,
};

// This not passing typing for a mysterious reason
// export const CategoryFormSchema = z.object({
//     image: z.any().nullable(),
//     title: z
//         .string()
//         .min(1, 'Le titre est requis')
//         .max(100, 'Le titre ne peut pas dépasser 100 caractères')
//         .default(''),
//     indexDisplay: z.number().int().min(0, "L'index d'affichage doit être positif").default(0),
//     isPunctual: z.boolean().default(false),
//     isFreefood: z.boolean().default(false),
//     isMicrostore: z.boolean().default(false),
//     shouldShowSubcategories: z.boolean().default(false),
// });

// const defaultValues = getZodDefaults(CategoryFormSchema);
